import React, { useEffect, useState } from 'react';
import SongRepository from '../../service/SongRepository';

export default function TabLoader({ tabCode, renderPlayer }) {

    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [song, setSong] = useState(null);

    useEffect(() => {
        const load = async (code) => {
            setLoading(true);
            try {
                const loadedTab = await SongRepository.getTab(code);
                await setSong(loadedTab);
            } catch (e) {
                setMessage('Не удалось загрузить табулатуру');
            } finally {
                setLoading(false)
            }
        };

        load(tabCode);
    }, [tabCode]);

    if (!song) {
        return <div>
            {message && <span className='b-error-message'>{message}</span>}
            {loading && <span className='b-loader'>Загружаем табулатуру...</span>}
        </div>;
    }

    return renderPlayer(song)
}
